export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40b18ea5f00f665c9a60ea670fc6eaffe29a058c16&name=revalidateCommunity!'